<template>
    <div>
        <nav-bar />
        <div class="main">
            <banner />
            <Main />
            <site-footer />
        </div>
    </div>
</template>

<script>
import NavBar from "../views/commons/NavBar";
import Banner from "../views/contactPage/Banner";
import Main from "../views/contactPage/main";
import SiteFooter from "../views/index-five/SiteFooter";

export default {
    name: "DownloadPage",
    components: {
        NavBar,
        Banner,
        Main,
        SiteFooter,
    },
};
</script>

